<div class="raise-bug-form">
  <h3>Raise Bug</h3>

  <!-- Suite Dropdown -->
  <label for="suite">Suite:</label>
  <select id="suite" [(ngModel)]="selectedSuite" [disabled]="noSuitesAvailable">
    <option value="" disabled selected *ngIf="!selectedSuite && !noSuitesAvailable">Select the artifact</option>
    <option *ngIf="noSuitesAvailable" disabled selected>No artifact present</option>
    <option *ngFor="let suite of suites" [value]="suite.id">{{ suite.name }}</option>
  </select>

  <!-- Feature Dropdown -->
  <label for="feature">Feature:</label>
  <select id="feature" [(ngModel)]="selectedFeature" [disabled]="noFeaturesAvailable">
    <option value="" disabled selected *ngIf="!selectedFeature && !noFeaturesAvailable">Select the artifact</option>
    <option *ngIf="noFeaturesAvailable" disabled selected>No artifact present</option>
    <option *ngFor="let feature of features" [value]="feature.id">{{ feature.name }}</option>
  </select>

  <!-- Scenario Dropdown -->
  <label for="scenario">Scenario:</label>
  <select id="scenario" [(ngModel)]="selectedScenario" [disabled]="noScenarioAvailable">
     <option value="" disabled selected *ngIf="!selectedScenario && !noScenarioAvailable">Select the artifact</option>
    <option *ngIf="noScenarioAvailable" disabled selected>No artifact present</option>
    <option *ngFor="let scenario of scenarios" [value]="scenario.id">{{ scenario.name }}</option>
  </select>

  <!-- Description Textarea -->
  <label for="description">Description:</label>
  <textarea id="description" [(ngModel)]="description" rows="4"></textarea>

  <!-- Submit Button -->
  <div class="submit-button-wrapper">
  <button (click)="submitBug()" [disabled]="!selectedSuite">Submit</button>
</div>
</div>